export default "__VITE_ASSET__CLzFPlbJ__"